import { Injectable } from '@angular/core';
import { EndUserViewDto } from '@osos/shared/api';
import { DataViewsPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { EndUserDataViewsParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class EndUserDataViewsFactoryService extends FactoryBase<
  EndUserViewDto,
  DataViewsPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: EndUserDataViewsParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(presenter: DataViewsPresenterModel): EndUserViewDto {
    const parser = this.getParser(
      EndUserViewDto,
      DataViewsPresenterModel,
      presenter.specificationVersion,
    );

    return parser.getDataModel(presenter);
  }

  createPresenterModel(model: EndUserViewDto): DataViewsPresenterModel {
    const parser = this.getParser(
      EndUserViewDto,
      DataViewsPresenterModel,
      model.specificationVersion || 1,
    );

    return parser.getPresenterModel(model);
  }
}
